import React from 'react';
import { Link } from 'react-router-dom';
import '../../styles/common/latte-components.css';

const BlogCard = ({ post }) => {
  const hasImage = post.cover_image_url && post.cover_image_url.trim() !== '';

  const getSummary = () => {
    if (post.summary) return post.summary;
    
    // HTML에서 텍스트만 추출하여 요약 생성
    if (post.content_html) {
      const div = document.createElement('div');
      div.innerHTML = post.content_html;
      const text = div.textContent || div.innerText || '';
      return text.substring(0, 150) + (text.length > 150 ? '...' : '');
    }
    
    return '내용 없음';
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const year = date.getFullYear();
    const month = date.getMonth() + 1;
    const day = date.getDate();
    return `${year}년 ${month}월 ${day}일`;
  };

  return (
    <Link to={`/blog/${post.slug || post.id}`} className="group block h-full">
      <div className="bg-white h-full flex flex-col transition-all duration-200 hover:shadow-md rounded-lg overflow-hidden group">
        {/* 이미지 영역 */}
        {hasImage && (
          <div className="relative h-48 overflow-hidden bg-gray-50">
            <img 
              src={post.cover_image_url} 
              alt={post.title}
              className="w-full h-full object-cover"
            />
          </div>
        )}
        
        <div className="flex-1 flex flex-col p-4">
          {/* 제목 */}
          <h3 className="text-base font-bold text-gray-900 mb-2 line-clamp-2 group-hover:text-amber-600 transition-colors">
            {post.title}
          </h3>
          
          {/* 요약 */}
          <p className="text-sm text-gray-600 mb-4 line-clamp-3 flex-1 leading-relaxed">
            {getSummary()}
          </p>
          
          {/* 날짜와 작성자 정보 */}
          <div className="flex items-center text-xs text-gray-500">
            <span>{formatDate(post.created_at)}</span>
            {post.author_name && (
              <>
                <span className="mx-1">·</span>
                <span>{post.author_name}</span>
              </>
            )}
          </div>
        </div>
      </div>
    </Link>
  );
};

export default BlogCard;
